import { SvgIcon, SvgIconProps } from "@mui/material";

type IconProps = SvgIconProps & {
	size?: number;
};

export const UploadIcon = ({ size = 20, ...props }: IconProps) => {
	return (
		<SvgIcon width={size} height={size} viewBox="0 0 24 24" {...props}>
			<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
				<path
					opacity="0.85"
					d="M3.3335 13.333V14.9997C3.3335 15.4417 3.50909 15.8656 3.82165 16.1782C4.13421 16.4907 4.55814 16.6663 5.00016 16.6663H15.0002C15.4422 16.6663 15.8661 16.4907 16.1787 16.1782C16.4912 15.8656 16.6668 15.4417 16.6668 14.9997V13.333M5.8335 7.49967L10.0002 3.33301M10.0002 3.33301L14.1668 7.49967M10.0002 3.33301V13.333"
					stroke="#FAFAFA"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</SvgIcon>
	);
};
